<div class="main cnt-row-centered" (click)="handleOnClose($event)">
    <div class="btn-close" attr.data-testid="{{testId}}"></div>
</div>